import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simed-reception-echantillion',
  templateUrl: './simed-reception-echantillion.component.html',
  styleUrls: ['./simed-reception-echantillion.component.scss']
})
export class SimedReceptionEchantillionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
